import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FileFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.19144 22.75C4.58211 22.75 3.27678 21.4403 3.27427 19.823L3.25 4.18619C3.24749 2.56532 4.55429 1.25 6.16717 1.25H12.9695C13.2271 1.25 13.4741 1.35268 13.6564 1.53551L20.4645 8.36329C20.6473 8.5466 20.75 8.79546 20.75 9.05498V19.8184C20.75 21.4375 19.4439 22.75 17.8328 22.75H6.19144ZM18.8043 9.46094L12.5673 3.20594V7.96094C12.5673 8.78936 13.2389 9.46094 14.0673 9.46094H18.8043ZM7.25391 18C7.25391 18.4142 7.58969 18.75 8.00391 18.75H16.0039C16.4181 18.75 16.7539 18.4142 16.7539 18C16.7539 17.5858 16.4181 17.25 16.0039 17.25H8.00391C7.58969 17.25 7.25391 17.5858 7.25391 18ZM8.00391 14.75C7.58969 14.75 7.25391 14.4142 7.25391 14C7.25391 13.5858 7.58969 13.25 8.00391 13.25H12.0039C12.4181 13.25 12.7539 13.5858 12.7539 14C12.7539 14.4142 12.4181 14.75 12.0039 14.75H8.00391Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FileFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FileFilledIcon;
